import { useCallback, useMemo } from 'react';
import { useTrackingDispatch } from '../TrackingDispatchContext';
import { Trackers } from '../types';

export default function useDebugEventTracking() {
  const { dispatch } = useTrackingDispatch();

  const trackMouseDown: Trackers['trackMouseDown'] = useCallback(
    (props) => {
      dispatch({ event: 'browserMouseDown', payload: props });
    },
    [dispatch],
  );

  const trackMouseUp: Trackers['trackMouseUp'] = useCallback(
    (props) => {
      dispatch({ event: 'browserMouseUp', payload: props });
    },
    [dispatch],
  );

  const trackTouchStart: Trackers['trackTouchStart'] = useCallback(
    (props) => {
      dispatch({ event: 'browserTouchStart', payload: props });
    },
    [dispatch],
  );

  const trackTouchEnd: Trackers['trackTouchEnd'] = useCallback(
    (props) => {
      dispatch({ event: 'browserTouchEnd', payload: props });
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      trackMouseDown,
      trackMouseUp,
      trackTouchEnd,
      trackTouchStart,
    }),
    [trackMouseDown, trackMouseUp, trackTouchEnd, trackTouchStart],
  );
}
